import { DomErrorHandlerBase, DomErrorHandlerEvents, IoCContainer, IWebCoreIoCContainer, WebCoreIoCKeys } from '@lmnop/web-core';

export class OnErrorSavedToDomStorageEventArgs {
    constructor(translationMissing: boolean) {
        this.translationMissing = translationMissing;
    }

    public translationMissing: boolean;
}
export class WebsiteDomErrorHandler extends DomErrorHandlerBase {
    private get ioc(): IWebCoreIoCContainer {
        return IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
    }

    public saveErrorToDom(translationMissing: boolean, message?: any, ...optionalParams: any[]): void {
        let optionalParamsString: string = '';
        optionalParams.forEach(optionalParam => {
            optionalParamsString += optionalParam;
        });

        let errorString: string = 'message: ' + message + ' optionalParamsString: ' + optionalParamsString + '¤¤¤' + this.ioc.settings.applicationName;

        try {
            let eventHandler = IoCContainer.get(WebCoreIoCKeys.IEventHandler);
            if (translationMissing) {
                eventHandler.emit(DomErrorHandlerEvents.SAVE_ERROR_TO_DOM, new OnErrorSavedToDomStorageEventArgs(translationMissing));
            } else {
                eventHandler.emit(DomErrorHandlerEvents.SAVE_ERROR_TO_DOM, errorString);
            }
        } catch (error) {
            console.log(error);
        }
    }

    public getClientErrorString(): string {
        let errorDiv = document.getElementById('wecdev-error-storage');
        if (!errorDiv) {
            return '';
        }

        let spans = errorDiv.getElementsByTagName('span');
        let errors: string[] = [];
        for (let i = 0; i < spans.length; i++) {
            let error = spans[i].textContent;
            if (error) {
                errors.push(error);
            }
        }

        return errors.join('¤¤¤');
    }

    public clearDomErrorStorage(): void {
        let errorDiv = document.getElementById('wecdev-error-storage');
        if (!errorDiv) {
            return;
        }

        errorDiv.innerHTML = '';
    }
}
